import React, { useState, useEffect } from 'react';
import { Search as SearchInput, Modal, Typography } from '@telus-uds/components-web';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import _ from 'lodash';
import OCDRFilters from '../../filters/ocdrFilters';
import request, { apiHost, config as axiosConfig, isSmReadOnly } from '../../utils/request';
import { ContentWrapper, Box } from '../../design/css';
import { Search } from './css';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import Table from '../../design/shared/table';
import { OrderListModel } from './models';

import ValidateLoader from '../../UI/validateLoader';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { ocdrForm, orderStatus } from '../../utils/constant';
import { getButton, getStatus, getStatusFiltersPayload } from './utils';
import MessageNotification from '../../messageNotification';
import stringInterpolation from '../../utils/stringInterpolation';
import { useLocaleContext } from '../../context/LocaleContext';
import { getFormattedDate } from '../../utils/utils';

import View from './components/view';
import { getOptions, ChannelModel } from '../../orders/models';

const ordersConnectionKey = 'ORDERS';

const initialFilterState = {
  startDate: null,
  endDate: null,
  completedStartDate: null,
  completedEndDate: null,
  province: [],
  channelId: [],
  productId: [],
  status: [],
  submitter: [],
  dealership: [],
  salesRepName: []

};

const myOrdersDashboardOCDR = ({ location: { search }, userId }) => {
  let url = '';
  const local = useLocaleContext();
  const {
    OCDR:{
      orderDashoard: {
      FMLandingPage: { searchLabel, searchHint },
      confirmationDialog,
      noOrders,
      loadingMessage,
      confirm,
      cancel,
      proceedWithOrder,
      locked,
      continueLabel,
      continueAction,
      cancelAction,
      confirmationMessage,
      manage,
      successActionMessage,
      status,
      statuses,
      products,
      headerMyOrder,
      modify
    }
  }
  } = local === 'en-US' ? EN : FR;

  const localizedStrings = useLocalizedStringsContext();
  const staticLabelsForFilters = localizedStrings[ordersConnectionKey];
  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { provinces } = userProfile;

  const history = useHistory();
  const { q } = queryString.parse(history.location.search);
  const [searchString, setSearchString] = useState(q);
  const [filterState, setFilterState] = useState(initialFilterState);
  const [filters, setFilters] = useState('');
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [data, setData] = useState();
  const [action, setAction] = useState();
  const [channels, setChannels] = useState(null);
  const [submitters, setSubmitters] = useState(null);
  const [dealerships, setDealerShips] = useState(null);
  const [salesRepNames, setSalesRepNames] = useState(null);
  const [isOrderUpdated, setOrderUpdated] = useState();
  const [message, setMessage] = useState('has been successfully updated');

  const SrtPage = localStorage.getItem('myOrderPageNo')
    ? localStorage.getItem('myOrderPageNo')
    : 1;
  const [srtPage, setSrtPage] = useState(SrtPage);
  const [tableHeaders, setTableHeaders] = useState(headerMyOrder);
  const { page } = queryString.parse(search);
  const pageSize = 50;
  const filterData = {
    statuses,
    provinces,
    products,
    channels,
    submitters,
    dealerships,
    salesRepNames
  };
  useEffect(() => {
    setTableHeaders(headerMyOrder);
  }, [local]);

  const updateFilters = (key, value) => {
    setFilterState({ ...filterState, [key]: value });
  };

  const resetFilters = () => {
    setSrtPage(1); // reset state of page number to page = 1
    setFilterState({
      ...initialFilterState
    });
    setFilters('');
    filterOrders(true);
  };

  const fetchOrders = () => {
    return request.get(
      `/orders?typeOfOrder=OCDR&pageNumber=${srtPage ||
        1}&pageSize=${pageSize}&${url}&createdBy=${userId}`
    );
  };
  const fetchData = () => {
    setLoading(true);
    fetchOrders().then(ordersResp => {
      const {
        data: { totalCount: ordersCount, results: orders }
      } = ordersResp;
      setData({
        orders,
        count: ordersCount
      });
      setLoading(false);
    });
  };

  const fetchFiltersData = async () => {
    return axios
      .get(`${apiHost}/get-wln-filters?${url}`, axiosConfig())
      .then(response => {
        setSubmitters(_.get(response, 'data.usersList', 0));
        setChannels(
          getOptions(_.get(response, 'data.channels', 0), ChannelModel)
        );
        setDealerShips(_.get(response, 'data.dealerships', 0));
        setSalesRepNames(_.get(response, 'data.salesReps', 0));
      })
      .catch();
  };

  const cancelOrder = () => {
    request
      .put(`/orders/${order.id}`, { status: 'ORDER_CANCELED' })
      .then(() => {
        setOrder({ ...order, open: false, isUpdated: true });
        fetchData();
      });
  };

  const getRedirectUrl = (row, formName) => {
    let steps;
    if (row.status === orderStatus.SendBacktoAccountManager) {
      steps = 1;
    } else {
      steps = row.step;
    }
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=${steps}&isEditing=true`
    });
    window.location.reload();
  };

  const getModifyUrl = (row, formName) => {
    history.push({
      pathname: `/${row.locale}/${row.categoryName}/${formName}`,
      search: `?orderId=${row.id}&step=1&isEditing=true`
    });
    setOrder({ ...order, open: false });
    window.location.reload();
  };

  const getFilterPayload = () => {
    const payload = {
      ...filterState,
      submittedBy:
        filterState.submitter.length && filterState.submitter[0].value,
      province: filterState.province.map(row => row.value),
      channelId: filterState.channelId.map(row => row.value)
    };

    if (filterState.startDate)
      payload.startDate = getFormattedDate(filterState.startDate);
    if (filterState.endDate)
      payload.endDate = getFormattedDate(filterState.endDate);
    if (filterState.completedStartDate)
      payload.completedStartDate = getFormattedDate(
        filterState.completedStartDate
      );
    if (filterState.completedEndDate)
      payload.completedEndDate = getFormattedDate(
        filterState.completedEndDate
      );
    return payload;
  };

  const getFilterParams = payload => {
    let allFilterParamsArray = {};
    if (payload.province && payload.province.length) {
      allFilterParamsArray.province = payload.province.map((n, index) => n);
    }
    if (payload.channelId && payload.channelId.length) {
      allFilterParamsArray.channelId = payload.channelId.map((n, index) => n);
    }
    if (payload.productId && payload.productId.length) {
      allFilterParamsArray.product = payload.productId.flatMap(
        (n, index) => n.value
      );
    }
    if (payload.status && payload.status.length) {
      const { status } = getStatusFiltersPayload(payload.status);
      if (status.length) allFilterParamsArray.status = status;
    }
    if (payload.channelOrgCode && payload.channelOrgCode.length) {
      allFilterParamsArray.channelOrgCode = payload.channelOrgCode.map(
        (n, index) => n.value
      );
    }
    if (payload.startDate) {
      allFilterParamsArray.startDate = payload.startDate;
    }
    if (payload.endDate) {
      allFilterParamsArray.endDate = payload.endDate;
    }
    if (payload.completedStartDate) {
      allFilterParamsArray.completedStartDate = payload.completedStartDate;
    }
    if (payload.completedEndDate) {
      allFilterParamsArray.completedEndDate = payload.completedEndDate;
    }
    if (payload.startDate || payload.endDate) {
      allFilterParamsArray.filterCriteria = 'createdAt';
    }
    if (payload.submitter && payload.submitter.length) {
      allFilterParamsArray.submitter = payload.submitter.map(
        (n, index) => n.value
      );
    }
    if(payload.dealership && payload.dealership.length){
      allFilterParamsArray.dealership = payload.dealership.map((n, index) => n.value)
    }
    if(payload.salesRepName && payload.salesRepName.length){
      allFilterParamsArray.salesRepName = payload.salesRepName.map((n, index) => n.value)
    }
    return allFilterParamsArray;
  };

  const filterOrders = (isResetMode = false) => {
    if (isResetMode === true) {
      fetchData();
    } else {
      const payload = getFilterPayload();
      setLoading(true);
      const allFilterParamsArray = getFilterParams(payload);
      setFilters(allFilterParamsArray);
      axios
        .post(
          `${apiHost}/orders/filter?typeOfOrder=OCDR&pageNumber=${srtPage}&pageSize=${pageSize}&${url}&createdBy=${userId}`,
          { ...allFilterParamsArray, createdBy: userProfile.id },
          { ...axiosConfig() }
        )
        .then(response => {
          const {
            data: { totalCount: ordersCount, results: orders }
          } = response;
          setData({
            orders,
            count: ordersCount
          });
          setLoading(false);
        })
        .catch(() => {});
    }
  };

  const applyFilters = () => {
    setSrtPage(1);
    localStorage.setItem('myOrderPageNo', 1);
    filterOrders();
  };

  const onSave = value => {
    setMessage('has been successfully updated');
    window.scrollTo(0, 0);
    setOrderUpdated(value);
  };

  const actionContinue = row => {
    setAction(continueAction);
    setOrder({ open: true, orderDetails: row });
  };

  const actionCancel = (id, orderId) => {
    setAction(cancelAction);
    setOrder({ open: true, id, orderId });
  };

  const actionProceed = row => {
    setAction(proceedWithOrder);
    setOrder({ open: true, orderDetails: row });
  };

  const actionModify = row => {
    setAction(modify);
    setOrder({ open: true, orderDetails: row });
  };

  const onConfirm = () => {
    switch (action) {
      case continueAction:
        getRedirectUrl(order.orderDetails, ocdrForm);
        break;
      case cancelAction:
        cancelOrder();
        break;
      case modify:
        getModifyUrl(order.orderDetails, ocdrForm);
        break;
      default:
    }
  };
  const getActions = row => {
    const smReadOnly = isSmReadOnly();
    const { status: orderStatus } = row;
    const finalStatus = getStatus(orderStatus);

    const incompleteStatus = finalStatus === status.orderIncomplete;
    const pendingApproval = finalStatus === status.pendingApproval;
    const quoteApproved = finalStatus === status.quoteApproved;
    const quoteRejected = finalStatus === status.quoteRejected;
    const contractSent = finalStatus === status.contractSent;
    const contractSigned = finalStatus === status.contractSigned;
    const orderCompleted = finalStatus === status.orderCompleted;
    const canceledStatus = finalStatus === status.orderCanceled;
    const sendBacktoAccountManager =
      finalStatus === status.sendBacktoAccountManager;

    let actions;
    if (incompleteStatus) {
      actions = (
        <>
          {!smReadOnly && getButton(() => actionContinue(row), continueLabel)}
          {!smReadOnly && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (pendingApproval) {
      const orderData = row;
      actions = (
        <>
          <View orderData={orderData} onSave={onSave} fetchData={fetchData} />
          {!smReadOnly && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (quoteApproved) {
      const orderData = row;
      actions = (
        <>
          <View orderData={orderData} onSave={onSave} fetchData={fetchData} />
          {!smReadOnly && getButton(() => actionModify(row), modify)}
          {!smReadOnly && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (quoteRejected) {
      actions = (
        <>
          {!smReadOnly && getButton(() => actionModify(row), modify)}
          {!smReadOnly && getButton(() => actionCancel(row.id, row.orderId), cancel)}
        </>
      );
    } else if (contractSigned || orderCompleted || contractSent) {
      const orderData = row;
      actions = (
        <View orderData={orderData} onSave={onSave} fetchData={fetchData} />
      );
    } else if (canceledStatus) {
      actions = <>{getButton(() => actionProceed(row), locked, true)}</>;
    }
    return actions;
  };

  const onSearchClick = () => {
    setSrtPage(1);
    localStorage.setItem('myOrderPageNo', 1);
    history.push({
      search: `?q=${searchString}`
    });
    if (searchString) {
      url = `q=${searchString}`;
      fetchData();
    } else if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  };

  const onClear = () => {
    setSearchString('');
    setSrtPage(1);
    localStorage.setItem('myOrderPageNo', 1);
    history.push({
      search: ''
    });
    url = filters;
    if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  };

  useEffect(() => {
    (async () => {
      await fetchFiltersData();
    })();
    if (searchString) {
      url = `q=${searchString}`;
      setSrtPage(1);
      localStorage.setItem('myOrderPageNo', 1);
    }
  }, []);

  // Search fetch only fires on submit/clear (see onSearchClick/onClear), not on every keystroke
  useEffect(() => {
    if (searchString) {
      url = `q=${searchString}`;
      fetchData();
    } else if (filters) {
      filterOrders();
    } else {
      fetchData();
    }
  }, [page, srtPage]);

  return (
    <>
      <div style={{ padding: '0 6rem' }}>
        <OCDRFilters
          updateFilters={(key, value) => updateFilters(key, value)}
          filterState={filterState}
          onApplyFilters={applyFilters}
          onResetFilters={resetFilters}
          data={filterData}
          staticLabels={staticLabelsForFilters}
          // isMyOrder={true} //use to hide some filters on Myorder Dashboard
        />
        <Search>
          <div></div>
          <div style={{ marginLeft: 20 }}>
            <SearchInput
              placeholder={searchHint || searchLabel}
              value={searchString || ''}
              onClear={() => onClear()}
              onChange={value => {
                setOrder({ ...order , isUpdated: false });
                setSearchString(value)
              }}
              onSubmit={() => onSearchClick()}
            />
          </div>
        </Search>
      </div>
      {isOrderUpdated && isOrderUpdated.isUpdated && (
        <Box top={4} bottom={4}>
          <MessageNotification
            variant={{ validation: 'success' }}
            message={`${'Order with Order ID:'}${
              isOrderUpdated.orderId
            } ${message}`}
          />
        </Box>
      )}
      <ContentWrapper>
        {loading ? (
          <ValidateLoader message={loadingMessage} />
        ) : (
          <>
            {order && order.isUpdated && (
              <Box top={4} bottom={4}>
                <MessageNotification
                  variant={{ validation: 'success' }}
                  message={stringInterpolation(
                    successActionMessage,
                    action,
                    order.orderId
                  )}
                />
              </Box>
            )}
            {data && data.orders && data.orders.length ? (
              <>
                <Table
                  title={manage}
                  header={tableHeaders}
                  data={data.orders}
                  actions={getActions}
                  dataModel={OrderListModel}
                  currentPage={parseInt(srtPage || 1, 10)}
                  setSrtPage={setSrtPage}
                  count={data.count}
                  actionsDisplay="grid"
                  step={pageSize}
                />
              </>
            ) : (
              <div style={{ textAlign: 'center' }}><Typography block>{noOrders}</Typography></div>
            )}
          </>
        )}
        {
          <Modal
            heading={confirmationDialog}
            bodyText={`${confirmationMessage} ${action} ?`}
            confirmButtonText={confirm}
            cancelButtonText={cancel}
            onConfirm={() => onConfirm()}
            onClose={() => setOrder({ ...order, open: false })}
            isOpen={action && order.open}
          />
        }
      </ContentWrapper>
    </>
  );
};

myOrdersDashboardOCDR.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }).isRequired
};

export default myOrdersDashboardOCDR;
